import { useTranslations } from 'next-intl';

export const EmptyState = ({ activeTab }: { activeTab: 'system' | 'interaction' }) => {
  const t = useTranslations();

  return (
    <div className="flex h-[140px] flex-col items-center justify-center text-sm md:h-[calc(100%-64px)]">
      <span className="text-system-white64">
        {activeTab === 'system' ? t('notifications.empty') : t('notifications.interaction.empty')}
      </span>
    </div>
  );
};
